import dayjs from 'dayjs'

dayjs.locale('ko')

export function toYYYYMMDD(date: Date | string | number) {
  return dayjs(date).format('YYYY-MM-DD')
}

export function toYYYYMMDDHHmmss(date: Date | string | number) {
  return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
}

export const toYYYYMMDDHHmm = (date: Date | string | number) => dayjs(date).format('YYYY-MM-DD HH:mm')

export function toMidnight() {
  return dayjs(new Date().setHours(24, 0, 0, 0)).diff(dayjs())
}

export function toHHmm(date: Date | string | number) {
  return dayjs(date).format('HH:mm')
}
